import React from "react";
import { Modal, Form } from "antd";
import { Button, Input } from "antd";
import Axios from "../../../api/Axios";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
const EditNaics = ({
  visible,
  onCancel,
  modalData,
  CreateSuccessfull,
  CreateFailed,
}) => {
  //console.log(modalData.id);
  //console.log(modalData?.code);
  //console.log(modalData.title);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    //console.log("Form values:", values);
    try {
      await Axios.put(`/naics/${modalData.id}/`, values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("edited");
    } catch (err) {
      //console.log(err);
      CreateFailed("edited");
    }
  };
  const handleCancel = () => {
    onCancel();
  };
  return (
    <Modal
      title={<p className="modal-heading">EDIT NAICS CODE</p>}
      centered
      // open={modalOpen}
      // onOk={() => setModalOpen(false)}
      // onCancel={() => setModalOpen(false)}
      open={visible}
      onCancel={handleCancel}
      footer={[]}
    >
      <Form
        onFinish={onFinish2}
        style={{ marginTop: "3rem" }}
        name="complex-form"
      >
        <Form.Item
          label={<p className="modal-text">NAICS Code</p>}
          name="code"
          rules={[
            { required: true, message: "Please input a NAICS code" },
            {
              pattern: /^[0-9]{6}$/,
              message: "NAICS code should be a 6-digit number",
            },
          ]}
          initialValue={modalData.code}
        >
          <Input placeholder="Enter NAICS code" />
        </Form.Item>
        <Form.Item
          label={<p className="modal-text">NAICS Title</p>}
          name="title"
          rules={[
            { required: true, message: "Please input a title" },
            {
              max: 100,
              message: "Title should not exceed 100 characters",
            },
          ]}
          initialValue={modalData.title}
        >
          <Input placeholder="Enter title" />
        </Form.Item>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#f58029",
                fontWeight: "600",
              }}
              className="save-update-btn"
            >
              Update
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default EditNaics;
